import { render, staticRenderFns } from "./ProfileContact.vue?vue&type=template&id=d41c2fb8&scoped=true&"
import script from "./ProfileContact.vue?vue&type=script&lang=js&"
export * from "./ProfileContact.vue?vue&type=script&lang=js&"
import style0 from "./ProfileContact.vue?vue&type=style&index=0&id=d41c2fb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41c2fb8",
  null
  
)

export default component.exports